<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card :loading="loading">
              <v-card-title class="pb-5">
                <!--                                <v-btn @click="$router.push('/role')" class="btn-exit">-->
                <!--                                    <span class="flaticon2-reply icon-lg"></span>-->
                <!--                                    بازگشت-->
                <!--                                </v-btn>-->
                <!--                                <v-spacer/>-->
                <!--                                {{ $t($route.meta.title) }}-->
                <!--                                <v-spacer/>-->
                <v-btn
                  @click="updatePack"
                  class="btn-update"
                  :loading="loading"
                >
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="title"
                      :error-messages="errors.name"
                      label="عنوان لاتین"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="title_fa"
                      :error-messages="errors.name_fa"
                      label="نام فارسی"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <permission-picker
                      v-model="permissions"
                      :selectedPermissions="selectedPermissions"
                      :errors="errors.permissions_id"
                    ></permission-picker>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import permissionPicker from "@/view/pages/pickers/permissionPicker";

export default {
  props: ["id"],
  components: { permissionPicker },

  data() {
    return {
      ebi: "media/svg/icons/Navigation/Waiting.svg",
      service: [],
      services: [],
      selectedPermissions: {},
      title: null,
      loading: false,
      title_fa: null,
      expire: null,
      subline: {},
      permissions: {},
      tariff: { id: null },
      tariffs: [],
      owner: { id: null },
      owners: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      show: { id: null },
      shows: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      role: { id: null },
      roles: [],
      errors: [],
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
        permissions: [
          (val) => (val || []).length > 0 || "فیلد دسترسی الزامی می باشد.",
        ],
        tariff: [(val) => !!val || "فیلد تعرفه الزامی می باشد."],
      },
      url: "admin/roles",
    };
  },

  mounted() {
    this.getPack();
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  methods: {
    getPack() {
      this.loading = true;
      this.requestApiGet(`${this.url}/${this.id}`).then(({ data }) => {
        this.loading = false;
        this.title = data.name;
        this.title_fa = data.name_fa;
        this.permissions = data.permission;
      });
    },
    updatePack() {
      this.loading = true;
      // let checkedPermission = []
      // for (let a in this.permissions) {
      //   checkedPermission.push(a)
      // }
      this.requestApiPost(`${this.url}/${this.id}`, {
        name: this.title,
        name_fa: this.title_fa,
        permissionStatus: this.selectedPermissions,
        _method: "PUT",
      })
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("با موفقیت ویرایش شد.");
          this.$router.push({ name: "roles.index" });
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response.data.errors;
        });
    },
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    },
  },
};
</script>
